import { ACCESS_USER_TYPE, ACCESS_USER_FEATURELIST } from "./constants";

export const checkAppAccessibility = (userType, featureList = []) => {

    if (!userType || !ACCESS_USER_TYPE || !ACCESS_USER_FEATURELIST) return false;
    let parsedFeatureList = featureList;
    if (typeof featureList === "string") {
        try {
            parsedFeatureList = JSON.parse(featureList);
        } catch {
            return false;
        }
    }

    if (!Array.isArray(parsedFeatureList)) return false;
    const accessibleUsers = ACCESS_USER_TYPE.split(" ").map((val) => val.toUpperCase());
    const accessibleFeatures = ACCESS_USER_FEATURELIST.split(" ");
    const isUserAllowed = accessibleUsers.includes(userType.toUpperCase());
    const isFeatureAllowed =
        parsedFeatureList.some(feature =>
            accessibleFeatures.includes(feature)
        );
    return isUserAllowed && isFeatureAllowed;
}